/**
 * 見積書PDF生成モジュール v5.0
 * 最適化:
 * 1. PDF を cs@ergopro.jp へ添付メール送信（Web3Forms Pro）
 * 2. お客様へも PDF 添付メールを自動送信
 */

(function () {
  'use strict';

  var COMPANY_INFO = {
    name: 'DECOHUB合同会社',
    zip: '〒123-0851',
    address: '東京都足立区梅田1－13－4',
    registrationNo: '登録番号：T8011803004906',
    logoUrl: 'https://cdn.shopifycdn.net/s/files/1/0865/1377/8968/files/ergopro-png-9_09fd0f88-5fd7-4b24-b8e8-971d1e56e6b8.png?v=1714033605',
    /*stampUrl: 'https://cdn.shopify.com/s/files/1/0549/7307/1607/files/stamp.jpg?v=1679633916',*/
  };

  var BANK_INFO = {
    bankName: 'GMOあおぞらネット銀行',
    companyName: 'DECOHUB合同会社',
    branchName: '法人第二営業部',
    accountNumber: '1222148',
    accountType: '普通預金',
    accountHolder: 'デコハブ(ド',
    note: 'お振込手数料はお客様ご負担にてお願い致します。',
  };

  var TAX_RATE    = 0.1;
  var NOTIFY_EMAIL = 'cs@ergopro.jp';

  // ============================================================
  // Web3Forms Pro 設定
  // Form A: CS通知専用（Auto Responder: OFF）
  // Form B: お客様通知専用（Auto Responder: ON）
  // ============================================================
  var WEB3FORMS_CS_KEY       = '24c6b78d-cf9e-4b80-a275-dc198a94b33b'; // CS通知用
  var WEB3FORMS_CUSTOMER_KEY = '7cfad071-cd24-45dd-bf0d-6a818590739f'; // お客様通知用


  // ============================================================
  // 見積書番号生成（形式: M-EP-YYMMDD-XXXX）
  // ============================================================
  function generateUniqueQuoteNumber() {
    var d = new Date();
    var datePart = String(d.getFullYear()).slice(-2)
      + String(d.getMonth() + 1).padStart(2, '0')
      + String(d.getDate()).padStart(2, '0');
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var randomPart = '';
    var array = new Uint8Array(4);
    window.crypto.getRandomValues(array);
    array.forEach(function(byte) { randomPart += chars[byte % chars.length]; });
    var quoteNo = 'M-EP-' + datePart + '-' + randomPart;
    var usedKey = 'ergopro_used_quotes';
    var used = [];
    try { used = JSON.parse(localStorage.getItem(usedKey) || '[]'); } catch (e) {}
    if (used.indexOf(quoteNo) !== -1) {
      quoteNo = quoteNo + '-' + String(d.getMilliseconds()).padStart(3, '0');
    }
    used.push(quoteNo);
    if (used.length > 50) used = used.slice(used.length - 50);
    try { localStorage.setItem(usedKey, JSON.stringify(used)); } catch (e) {}
    return quoteNo;
  }

  // ============================================================
  // ユーティリティ
  // ============================================================
  function formatMoney(amount) { return amount.toLocaleString('ja-JP'); }

  function formatDate() {
    var d = new Date();
    return d.getFullYear() + '年'
      + String(d.getMonth() + 1).padStart(2, '0') + '月'
      + String(d.getDate()).padStart(2, '0') + '日';
  }

  function esc(str) {
    if (!str) return '';
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  // blob → base64 文字列に変換
  function blobToBase64(blob) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onloadend = function() { resolve(reader.result.split(',')[1]); };
      reader.onerror   = reject;
      reader.readAsDataURL(blob);
    });
  }

  // ============================================================
  // カートHTMLからキャンペーン名を収集
  // ============================================================
  async function fetchDiscountTitlesFromCartHTML() {
    try {
      var res = await fetch('/cart?t=' + Date.now(), {
        cache: 'no-store',
        headers: { 'Cache-Control': 'no-cache' },
      });
      if (!res.ok) return [];
      var html = await res.text();
      var titles = [];
      var pattern = /class="[^"]*cart__discount[^"]*"[^>]*>([^<]+)</g;
      var m;
      while ((m = pattern.exec(html)) !== null) {
        var raw     = m[1].trim();
        var cleaned = raw.replace(/\s*\([\-−]?[¥￥][\d,]+\)\s*$/, '').trim();
        if (!cleaned) continue;
        var inner = cleaned.match(/[「｢]([^」｣]+)[」｣]/);
        var title = inner ? inner[1] : cleaned;
        if (title && titles.indexOf(title) === -1) titles.push(title);
      }
      console.log('[見積書] キャンペーン名:', titles);
      return titles;
    } catch (e) {
      console.warn('[見積書] cart HTML フェッチエラー:', e);
      return [];
    }
  }

  function collectDiscounts(cart, htmlTitles) {
    var discountMap = {};
    htmlTitles = htmlTitles || [];
    var hasApps = cart.discount_applications && cart.discount_applications.length > 0;
    if (hasApps) {
      cart.items.forEach(function(item) {
        if (!item.discount_allocations || !item.discount_allocations.length) return;
        item.discount_allocations.forEach(function(alloc) {
          var app = cart.discount_applications[alloc.discount_application_index];
          if (!app) return;
          var title  = (app.title && app.title.trim()) || (app.code && app.code.trim()) || htmlTitles[alloc.discount_application_index] || 'キャンペーン割引';
          var amount = alloc.amount > 100 ? Math.round(alloc.amount / 100) : alloc.amount;
          if (!discountMap[title]) discountMap[title] = 0;
          discountMap[title] += amount;
        });
      });
    }
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      cart.cart_level_discount_applications.forEach(function(d, idx) {
        var title = (d.title && d.title.trim()) || (d.code && d.code.trim()) || htmlTitles[idx] || 'キャンペーン割引';
        if (!discountMap[title]) discountMap[title] = 0;
        discountMap[title] += d.total_allocated_amount || 0;
      });
    }
    if (!hasApps) {
      var totalDiff = 0;
      cart.items.forEach(function(item) {
        if (item.original_line_price && item.line_price) totalDiff += Math.max(0, item.original_line_price - item.line_price);
      });
      if (totalDiff > 0) {
        var title = htmlTitles[0] || (cart.discount_codes && cart.discount_codes.length ? cart.discount_codes.map(function(c){return c.code;}).join('/') : null) || '割引';
        if (!discountMap[title]) discountMap[title] = 0;
        discountMap[title] += totalDiff;
      }
    }
    return Object.keys(discountMap).filter(function(t){return discountMap[t]>0;}).map(function(t){return{title:t,amount:discountMap[t]};});
  }

  function collectMemos(cart) {
    var memos = [];
    cart.items.forEach(function(item) {
      if (!item.properties) return;
      var props = Array.isArray(item.properties)
        ? item.properties
        : Object.keys(item.properties).map(function(k){return{name:k,value:item.properties[k]};});
      var texts = [];
      props.forEach(function(prop) {
        var name  = String(prop.name  || '').trim();
        var value = String(prop.value || '').trim();
        if (!name || name.charAt(0) === '_' || !value) return;
        texts.push('【' + name + '】：' + value);
      });
      if (texts.length) memos.push({ productTitle: item.product_title, texts: texts });
    });
    return memos;
  }

  // ============================================================
  // カートデータ取得
  // ============================================================
  function normalizeCartPrices(cart) {
    cart.total_price = Math.round(cart.total_price / 100);
    cart.items.forEach(function(item) {
      item.price = Math.round(item.price / 100);
      item.line_price = Math.round(item.line_price / 100);
      if (item.original_price)      item.original_price      = Math.round(item.original_price / 100);
      if (item.original_line_price) item.original_line_price = Math.round(item.original_line_price / 100);
    });
    if (cart.cart_level_discount_applications) {
      cart.cart_level_discount_applications.forEach(function(d) {
        if (d.total_allocated_amount) d.total_allocated_amount = Math.round(d.total_allocated_amount / 100);
      });
    }
    return cart;
  }

  async function fetchCart() {
    var res = await fetch('/cart.js?t=' + Date.now(), { cache:'no-store', headers:{'Cache-Control':'no-cache','Pragma':'no-cache'} });
    if (!res.ok) throw new Error('カート情報の取得に失敗しました。');
    return normalizeCartPrices(await res.json());
  }

  async function fetchProductAsCart() {
    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) throw new Error('商品フォームが見つかりません。');
    var variantSelect = form.querySelector('select[name="id"], input[name="id"]');
    var variantId = variantSelect ? variantSelect.value : null;
    var qtyInput  = form.querySelector('input[name="quantity"]');
    var quantity  = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var res = await fetch(window.location.pathname + '.js?t=' + Date.now(), { cache:'no-store', headers:{'Cache-Control':'no-cache'} });
    if (!res.ok) throw new Error('商品情報の取得に失敗しました。');
    var product = await res.json();
    var variant = product.variants[0];
    if (variantId) { var found = product.variants.find(function(v){return String(v.id)===String(variantId);}); if (found) variant = found; }
    var priceYen  = Math.round(variant.price / 100);
    var linePrice = priceYen * quantity;
    return {
      total_price: linePrice,
      items: [{ product_title: product.title, variant_title: variant.title !== 'Default Title' ? variant.title : '',
        quantity: quantity, price: priceYen, line_price: linePrice,
        sku: variant.sku || '', product_id: product.id, variant_id: variant.id, properties: [] }],
      cart_level_discount_applications: [], discount_applications: [],
    };
  }

  async function getCartData() {
    if (window.location.pathname === '/cart') return fetchCart();
    if (window.location.pathname.startsWith('/products/')) return fetchProductAsCart();
    return fetchCart();
  }

  // ============================================================
  // メール本文生成（cs@ergopro.jp 用）
  // ============================================================
  function buildEmailBody(quoteNo, formData, cart, discounts, pdfLink) {
    var totalPrice = cart.total_price;
    var withoutTax = Math.round(totalPrice / (1 + TAX_RATE));
    var taxAmount  = totalPrice - withoutTax;

    var itemLines = cart.items.map(function(item, idx) {
      var unitExTax = Math.round(item.price / (1 + TAX_RATE));
      var line = (idx + 1) + '. ' + item.product_title;
      if (item.variant_title) line += '（' + item.variant_title + '）';
      line += '\n   数量        : ' + item.quantity;
      line += '\n   単価（税抜）: ¥' + formatMoney(unitExTax);
      line += '\n   単価（税込）: ¥' + formatMoney(item.price);
      line += '\n   小計        : ¥' + formatMoney(item.line_price);
      return line;
    }).join('\n\n');

    var discountLines = '';
    if (discounts && discounts.length) {
      discountLines = '\n\n--- 割引 ---\n' + discounts.map(function(d){return '  '+d.title+': -¥'+formatMoney(d.amount);}).join('\n');
    }

    var memos = collectMemos(cart);
    var memoLines = '';
    if (memos.length) {
      memoLines = '\n\n--- 備考 ---\n' + memos.map(function(m,i){
        return (i+1)+'. '+m.productTitle+'\n   '+m.texts.join('\n   ');
      }).join('\n\n');
    }

    return [
      '================================================================',
      '【見積書発行通知】',
      '================================================================',
      '',
      '見積書番号 : ' + quoteNo,
      '発行日     : ' + formatDate(),
      '',
      '----------------------------------------------------------------',
      '■ お客様情報',
      '----------------------------------------------------------------',
      'メールアドレス : ' + formData.email,
      '宛名           : ' + (formData.fullName || '未入力'),
      '会社名         : ' + (formData.company  || '未入力'),
      '',
      '----------------------------------------------------------------',
      '■ 商品明細',
      '----------------------------------------------------------------',
      itemLines + discountLines + memoLines,
      '',
      '----------------------------------------------------------------',
      '■ 金額',
      '----------------------------------------------------------------',
      '小計（税抜） : ¥' + formatMoney(withoutTax),
      '消費税（10%）: ¥' + formatMoney(taxAmount),
      '合計（税込） : ¥' + formatMoney(totalPrice),
      '',
      '================================================================',
      '※ 見積書PDFを添付しております。',
      (pdfLink ? 'PDFダウンロードリンク（14日間有効）: ' + pdfLink : ''),
      '================================================================',
    ].join('\n');
  }


  
  // ============================================================
  // message フィールド用：お客様向けメール本文
  // Web3FormsのIntro Textで {{message}} として表示される
  // ============================================================
  function buildCustomerMessage(quoteNo, pdfLink) {
    return [
      '見積書番号 : ' + quoteNo,
      '発行日     : ' + formatDate(),
      (pdfLink ? 'PDFダウンロードリンク（14日間有効）: ' + pdfLink : ''),
      '※ 見積書PDFを添付しております。',
      '',
      '----------------------------------------------------------------',
      '■ 振込先情報',
      '----------------------------------------------------------------',
      '銀行名   : ' + BANK_INFO.bankName,
      '支店名   : ' + BANK_INFO.branchName,
      '口座種類 : ' + BANK_INFO.accountType,
      '口座番号 : ' + BANK_INFO.accountNumber,
      '口座名義 : ' + BANK_INFO.accountHolder,
      '備考     : ' + BANK_INFO.note,
    ].join('\n');
  }

  // ============================================================
  // Web3Forms XHR 送信
  // ============================================================
  async function sendViaWeb3Forms(fd) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.web3forms.com/submit', true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.timeout = 30000;
      xhr.onload = function() {
        try {
          var data = JSON.parse(xhr.responseText);
          console.log('[見積書] Web3Forms送信:', data.success ? '成功' : '失敗', data.message || '');
          resolve(data);
        } catch(e) { reject(new Error('レスポンスのパースに失敗')); }
      };
      xhr.onerror   = function() { reject(new Error('ネットワークエラー')); };
      xhr.ontimeout = function() { reject(new Error('タイムアウト')); };
      xhr.send(fd);
    });
  }

  // ============================================================
  // gofile.io に PDF をアップロードして共有リンクを取得
  // 新APIエンドポイント: https://upload.gofile.io/uploadfile（直接アップロード）
  // ============================================================
  async function uploadPDFToFileIO(pdfBlob, filename) {
    try {
      var fd = new FormData();
      fd.append('file', pdfBlob, filename);

      var uploadRes = await new Promise(function(resolve, reject) {
        var x = new XMLHttpRequest();
        x.open('POST', 'https://upload.gofile.io/uploadfile', true);
        x.timeout = 30000;
        x.onload    = function() { resolve(x); };
        x.onerror   = function() { reject(new Error('upload failed')); };
        x.ontimeout = function() { reject(new Error('upload timeout')); };
        x.send(fd);
      });

      var uploadData = JSON.parse(uploadRes.responseText);
      if (uploadData.status === 'ok' && uploadData.data && uploadData.data.downloadPage) {
        console.log('[見積書] PDF共有リンク取得:', uploadData.data.downloadPage);
        return uploadData.data.downloadPage;
      }
      console.warn('[見積書] gofile.io レスポンス異常:', uploadRes.responseText);
      return null;
    } catch(e) {
      console.warn('[見積書] gofile.io アップロード失敗:', e);
      return null;
    }
  }

  // ============================================================
  // お客様向けメール本文
  // Web3Forms Intro Text に {{message}} を設定し、Copy Form Fields = ON にすること
  // ============================================================
  function buildCustomerMessage(quoteNo, pdfLink, customerName) {
    return [
      (customerName ? customerName + ' 様' : 'お客様'),
      '',
      '平素よりErgoProをご利用いただき、誠にありがとうございます。',
      '',
      'このたびは、御見積書の発行が完了いたしましたのでご案内申し上げます。',
      '御見積書の詳細およびダウンロードリンクは、以下よりご確認ください。',
      '',
      '見積書番号 : ' + quoteNo,
      'PDFダウンロードリンク（14日間有効）: ' + (pdfLink || 'リンクの取得に失敗しました'),
      '※ 見積書PDFを添付しております。',
      '',
      '----------------------------------------------------------------',
      '■ 振込先情報',
      '----------------------------------------------------------------',
      '銀行名   : ' + BANK_INFO.bankName,
      '支店名   : ' + BANK_INFO.branchName,
      '口座種類 : ' + BANK_INFO.accountType,
      '口座番号 : ' + BANK_INFO.accountNumber,
      '口座名義 : ' + BANK_INFO.accountHolder,
      '備考     : ' + BANK_INFO.note,
      '',
      'ご不明な点等がございましたら、下記までお気軽にお問い合わせください。',
      '――――――――――',
      '【連絡方法】',
      'LINEにてご連絡希望：https://page.line.me/440qfezx',
      'メールにてご連絡希望：cs@ergopro.jp',
      '【営業時間】',
      '月～金 10:30~18:00（日祝は除く）',
      '土曜日：時短勤務',
      '――――――――――',
      '',
      '今後ともErgoProを何卒よろしくお願い申し上げます。',
      'ErgoPro カスタマーサポート',
      '',
      '※本メールは自動配信メールとなっております。恐れ入りますが、ご返信には対応しておりません。',
    ].join('\n');
  }

  // ============================================================
  // 通知メール送信（2フォーム方式）
  // Form A (WEB3FORMS_CS_KEY)       : CS通知専用 / Auto Responder: OFF
  // Form B (WEB3FORMS_CUSTOMER_KEY) : お客様通知専用 / Auto Responder: ON
  // ============================================================
  async function sendNotifyEmail(quoteNo, formData, cart, discounts, pdfBlob, pdfFilename) {
    var customerName    = formData.company || formData.fullName || ''; // CS通知・件名用
    var customerSalute  = formData.fullName || formData.company || '';  // お客様メール宛名用（氏名優先）

    // gofile.io にアップロードしてPDFリンクを取得
    var pdfLink = null;
    if (pdfBlob) pdfLink = await uploadPDFToFileIO(pdfBlob, pdfFilename);

    var csBody      = buildEmailBody(quoteNo, formData, cart, discounts, pdfLink);
    var customerMsg = buildCustomerMessage(quoteNo, pdfLink, customerSalute);

    // ── Form A: CS通知（全詳細、Auto Responder OFF）
    var fdA = new FormData();
    fdA.append('access_key', WEB3FORMS_CS_KEY);
    fdA.append('subject',    '【見積書発行】' + quoteNo + ' ／ ' + (formData.company || formData.email));
    fdA.append('from_name',  'ErgoPro');
    fdA.append('email',      NOTIFY_EMAIL);
    fdA.append('name',       customerName);
    fdA.append('quote_no',   quoteNo);
    fdA.append('message',    csBody);
    fdA.append('botcheck',   '');
    if (pdfLink) fdA.append('pdf_link', pdfLink);

    // ── Form B: お客様通知（Auto Responder ON → お客様へ自動返信）
    // messageフィールドのみ送信 → Copy Form Fields = ON でも最小表示
    var fdB = new FormData();
    fdB.append('access_key', WEB3FORMS_CUSTOMER_KEY);
    fdB.append('subject',    '【ErgoPro】見積書発行のご確認');
    fdB.append('from_name',  'ErgoPro');
    fdB.append('email',      formData.email);  // auto-responder用（表示されない）
    fdB.append('message',    customerMsg);     // これだけ表示される
    fdB.append('botcheck',   '');

    console.log('[見積書] CS送信:', NOTIFY_EMAIL, '/ お客様送信:', formData.email, '/ quoteNo:', quoteNo);

    // CS送信 → 1秒待つ → お客様送信（連続送信によるスパム判定を回避）
    try {
      await sendViaWeb3Forms(fdA);
    } catch(e) {
      console.error('[見積書] CS送信エラー:', e);
    }

    await new Promise(function(resolve) { setTimeout(resolve, 1000); });

    try {
      await sendViaWeb3Forms(fdB);
    } catch(e) {
      console.error('[見積書] お客様送信エラー:', e);
    }
  }

  // ============================================================
  // 見積書 HTML 生成
  // ============================================================
  function buildFullHTML(cart, formData, quoteNo, htmlTitles) {
    var today        = formatDate();
    var totalPrice   = cart.total_price;
    var withoutTax   = Math.round(totalPrice / (1 + TAX_RATE));
    var taxAmount    = totalPrice - withoutTax;
    var customerName = esc(formData.company) || esc(formData.fullName) || 'お客様';

    var lineItemsHTML = '';
    cart.items.forEach(function(item) {
      var basePriceYen  = item.original_price || item.price;
      var unitPriceExTax = Math.round(basePriceYen / (1 + TAX_RATE));
      var optionsHTML = '';
      if (item.variant_title && !/^[¥\d,\s]+$/.test(item.variant_title.trim())) {
        optionsHTML += '<div style="font-size:11px;color:#555;margin-top:2px">' + esc(item.variant_title) + '</div>';
      }
      if (item.sku) optionsHTML += '<div style="font-size:11px;color:#555;margin-top:2px">SKU: ' + esc(item.sku) + '</div>';
      if (item.properties) {
        var props = Array.isArray(item.properties) ? item.properties : Object.keys(item.properties).map(function(k){return{name:k,value:item.properties[k]};});
        props.forEach(function(prop) {
          var name = String(prop.name||'').trim(), value = String(prop.value||'').trim();
          if (!name || name.charAt(0)==='_' || !value) return;
          optionsHTML += '<div style="font-size:11px;color:#555;margin-top:2px">'+esc(name)+': '+esc(value)+'</div>';
        });
      }
      lineItemsHTML += '<tr>'
        + '<td style="text-align:left;border:1px solid #000;padding:5px 8px;font-size:11px">'+esc(item.product_title)+optionsHTML+'</td>'
        + '<td style="text-align:center;border:1px solid #000;padding:5px 8px;font-size:11px">'+item.quantity+'</td>'
        + '<td style="text-align:right;border:1px solid #000;padding:5px 8px;font-size:11px">¥'+formatMoney(unitPriceExTax)+'</td>'
        + '<td style="text-align:center;border:1px solid #000;padding:5px 8px;font-size:11px">10%</td>'
        + '<td style="text-align:right;border:1px solid #000;padding:5px 8px;font-size:11px">¥'+formatMoney(item.original_line_price||item.line_price)+'</td>'
        + '</tr>';
    });

    var discounts = collectDiscounts(cart, htmlTitles);
    var discountRowsHTML = '';
    discounts.forEach(function(d) {
      discountRowsHTML += '<tr>'
        + '<td style="text-align:left;border:1px solid #000;padding:5px 8px;font-size:11px;color:#c00000">'+esc(d.title)+'</td>'
        + '<td style="text-align:center;border:1px solid #000;padding:5px 8px;font-size:11px;color:#c00000">-</td>'
        + '<td style="text-align:right;border:1px solid #000;padding:5px 8px;font-size:11px;color:#c00000">-</td>'
        + '<td style="text-align:center;border:1px solid #000;padding:5px 8px;font-size:11px;color:#c00000">-</td>'
        + '<td style="text-align:right;border:1px solid #000;padding:5px 8px;font-size:11px;color:#c00000">-¥'+formatMoney(d.amount)+'</td>'
        + '</tr>';
    });

    var totalRowHTML = '<tr>'
      + '<td colspan="4" style="text-align:right;border:1px solid #000;padding:5px 8px;font-size:11px;font-weight:600;background:#f5f5f5">合計：</td>'
      + '<td style="text-align:right;border:1px solid #000;padding:5px 8px;font-size:11px;font-weight:600;background:#f5f5f5">¥'+formatMoney(totalPrice)+'</td>'
      + '</tr>';

    var memos = collectMemos(cart);
    var remarksInner = '<span style="font-weight:600;font-size:12px">【備考欄】</span><br>';
    if (memos.length) {
      memos.forEach(function(m, i) {
        remarksInner += '<span style="font-size:11px">'+(i+1)+'. '+esc(m.productTitle)+'</span><br>';
        remarksInner += '<span style="font-size:11px">&emsp;'+m.texts.map(function(t){return esc(t);}).join('、')+'</span><br>';
      });
    } else {
      remarksInner += '&nbsp;';
    }

    return '<!DOCTYPE html><html lang="ja"><head><meta charset="utf-8">'
      + '<style>* { margin:0; padding:0; box-sizing:border-box; font-family:"Noto Sans JP","Hiragino Kaku Gothic ProN","Meiryo",sans-serif; } body { background:#fff; }</style>'
      + '<meta name="viewport" content="width=800, initial-scale=1">'
      + '<style>'
      + 'html, body { -webkit-text-size-adjust: 100% !important; -moz-text-size-adjust: 100% !important; text-size-adjust: 100% !important; }'
      + '* { margin:0; padding:0; box-sizing:border-box; font-family:"Noto Sans JP","Hiragino Kaku Gothic ProN","Meiryo",sans-serif; -webkit-text-size-adjust: 100% !important; text-size-adjust: 100% !important; }'
      + 'p, div, span, td, th, li { max-height: 1000000px; }'
      + 'body { background:#fff; }'
      + '</style>'
      + '</head><body><div id="pdf-content" style="width:88%;margin:30px auto;padding:20px;color:#000">'
      + '<div style="text-align:center;font-size:20px;font-weight:600;margin-bottom:25px;letter-spacing:6px">見 積 書</div>'
      + '<div style="display:flex;justify-content:space-between;margin-bottom:20px">'
      + '<div style="flex:0.58">'
      + '<div style="font-size:15px;font-weight:600;margin-bottom:5px">'+customerName+' 御中</div>'
      + '<div style="margin-bottom:30px"></div>'
      + '<div style="font-size:11px;margin-bottom:8px">下記の通りお見積り申し上げます。</div>'
      + '<table style="border-collapse:collapse;width:100%;margin-bottom:15px;border:1.5px solid #000">'
      + '<tr><th style="border:1px solid #000;padding:5px 8px;font-size:11px;background:#f5f5f5;font-weight:600;text-align:center">小計</th>'
      + '<th style="border:1px solid #000;padding:5px 8px;font-size:11px;background:#f5f5f5;font-weight:600;text-align:center">消費税</th>'
      + '<th style="border:1px solid #000;padding:5px 8px;font-size:11px;background:#f5f5f5;font-weight:600;text-align:center">合計金額</th></tr>'
      + '<tr><td style="text-align:right;border:1px solid #000;padding:5px 8px;font-size:11px">¥'+formatMoney(withoutTax)+'</td>'
      + '<td style="text-align:right;border:1px solid #000;padding:5px 8px;font-size:11px">¥'+formatMoney(taxAmount)+'</td>'
      + '<td style="text-align:right;border:1px solid #000;padding:5px 8px;font-size:11px"><strong>¥'+formatMoney(totalPrice)+'</strong></td></tr>'
      + '</table></div>'
      + '<div style="flex:0.38;text-align:right;padding-left:15px">'
      + '<div style="font-size:11px;display:flex;justify-content:space-between;margin-bottom:4px"><span>見積日</span><span>'+today+'</span></div>'
      + '<div style="font-size:11px;display:flex;justify-content:space-between;margin-bottom:25px"><span>見積書番号</span><span>'+esc(quoteNo)+'</span></div>'
      + '<div style="position:relative;text-align:left;padding:10px 0">'
      /*+ '<img src="'+COMPANY_INFO.stampUrl+'" style="position:absolute;top:0;left:35%;width:100px;height:100px;opacity:0.55;object-fit:contain" crossorigin="anonymous">'*/
      + '<p style="font-size:11px;margin-bottom:3px">'+COMPANY_INFO.name+'</p>'
      + '<p style="font-size:11px;margin-bottom:3px">'+COMPANY_INFO.zip+'</p>'
      + '<p style="font-size:11px;margin-bottom:3px">'+COMPANY_INFO.address+'</p>'
      + '<p style="font-size:11px;margin-bottom:3px">'+COMPANY_INFO.registrationNo+'</p>'
      + '</div>'
      + '<div style="text-align:right;margin-top:8px"><img src="'+COMPANY_INFO.logoUrl+'" style="max-width:130px;height:auto" crossorigin="anonymous"></div>'
      + '</div></div>'
      + '<table style="border-collapse:collapse;width:100%;margin-bottom:12px;border:1.5px solid #000">'
      + '<tr>'
      + '<th style="width:45%;border:1px solid #000;padding:5px 8px;font-size:11px;background:#f5f5f5;font-weight:600;text-align:center">詳細</th>'
      + '<th style="width:10%;border:1px solid #000;padding:5px 8px;font-size:11px;background:#f5f5f5;font-weight:600;text-align:center">数量</th>'
      + '<th style="width:15%;border:1px solid #000;padding:5px 8px;font-size:11px;background:#f5f5f5;font-weight:600;text-align:center">単価</th>'
      + '<th style="width:10%;border:1px solid #000;padding:5px 8px;font-size:11px;background:#f5f5f5;font-weight:600;text-align:center">税率</th>'
      + '<th style="width:20%;border:1px solid #000;padding:5px 8px;font-size:11px;background:#f5f5f5;font-weight:600;text-align:center">明細金額</th>'
      + '</tr>'
      + lineItemsHTML + discountRowsHTML + totalRowHTML
      + '</table>'
      + '<div style="border:1px solid #000;padding:8px 10px;margin-bottom:10px;min-height:50px;line-height:1.8;font-size:11px;page-break-inside:avoid">'+remarksInner+'</div>'
      + '<div style="border:1px solid #000;padding:8px 10px;margin-bottom:10px;min-height:50px;line-height:1.8;font-size:11px;page-break-inside:avoid">'
      + '<span style="font-weight:600;font-size:12px">【振込先情報】</span><br>'
      + '<span style="font-size:11px">銀行名: '+BANK_INFO.bankName+'<br>会社名: '+BANK_INFO.companyName+'<br>支店名: '+BANK_INFO.branchName+'<br>'
      + '口座番号: '+BANK_INFO.accountNumber+'<br>口座種類: '+BANK_INFO.accountType+'<br>口座名義: '+BANK_INFO.accountHolder+'<br>'
      + '('+BANK_INFO.note+')</span></div>'
      + '<div style="padding:8px 10px;margin-bottom:10px;min-height:50px;line-height:1.8;font-size:11px;page-break-inside:avoid">'
      + '<span style="font-weight:600;font-size:12px">【注意事項】</span><br>'
      + '<p style="font-size:10px;color:#555;margin-top:2px">'
      + '1. 有効期限：本見積書は、発行日より1週間を有効期限とさせていただきます。（※発行時点でキャンペーン対象の商品は、期間限定価格にて表記しております。）<br>'
      + '2. お振込み手数料につきましては、誠に恐れ入りますが、お客様にてご負担くださいますようお願い申し上げます。<br>'
      + '3. 商品のご購入は、弊社サイトよりご注文いただくか、カスタマーサポートまでお手続きをお願いいたします。事前のご連絡なくお振込みいただいた場合、ご注文内容の特定ができかねる場合がございますので、恐れ入りますが、事前にご一報くださいますようお願い申し上げます。<br>'
      + '4. お住まいの地域により、別途配送費用が発生する場合がございます。ご注文の際は、決済画面にて送料を含めた合計金額をご確認のうえ、お手続きをお願いいたします。<br>'
      + '5. 本見積書に記載の金額には、キャンペーン等による期間限定の割引が反映されている場合がございます。ご注文時にキャンペーン期間が終了している場合は、その時点のサイト掲載価格が適用されますので、あらかじめご理解賜りますようお願い申し上げます。<br>'
      + '6. 本見積書はシステムにより自動生成されているため、カスタマイズ商品の仕様や価格等は反映されておりません。カスタマイズをご希望の場合は、ご注文前にカスタマーサポートまでお気軽にお問い合わせください。<br>'
      + '7. 有料配送サービスおよび有料コーディネートサービスのご利用をご希望の場合も、カスタマーサポートまでお気軽にお問い合わせください。<br>'
      + '</p></div>'
      + '</div></body></html>';
  }

  // ============================================================
  // PDF 生成（iframe 方式）→ blob + base64 を返す
  // ============================================================
  async function generatePDF(cart, formData, quoteNo, htmlTitles) {
    var fullHTML    = buildFullHTML(cart, formData, quoteNo, htmlTitles);
    var pdfFilename = 'ErgoPro_Quote_' + quoteNo + '.pdf';

    return new Promise(function(resolve, reject) {
      var iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:fixed;left:-9999px;top:0;width:800px;height:1200px;border:none;';
      document.body.appendChild(iframe);

      var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      iframeDoc.open(); iframeDoc.write(fullHTML); iframeDoc.close();

      // devicePixelRatio を 1 に固定
      // html2canvas はこの値を scale に掛け合わせるため
      // モバイル(DPR=3)では scale=2×3=6倍になりフォントが大きくなる
      // 1に固定することで全デバイスで scale=2 の一定レンダリングを保証する
      try {
        Object.defineProperty(iframe.contentWindow, 'devicePixelRatio', {
          get: function() { return 1; },
          configurable: true,
        });
      } catch(e) {}

      var images = iframeDoc.querySelectorAll('img');
      Promise.all(Array.from(images).map(function(img) {
        if (img.complete) return Promise.resolve();
        return new Promise(function(r) { img.onload = r; img.onerror = r; });
      })).then(function() {
        var script = iframeDoc.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
        script.onload = function() {
          iframe.contentWindow.html2pdf().set({
            margin     : 10,
            image      : { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: false, logging: false },
            jsPDF      : { unit: 'mm', format: 'a4', orientation: 'portrait' },
          }).from(iframeDoc.getElementById('pdf-content'))
          .toPdf().get('pdf').then(function(pdf) {
            // ページ番号フッター
            var totalPages = pdf.internal.getNumberOfPages();
            for (var i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(9);
              pdf.setTextColor(150, 150, 150);
              pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 5, { align: 'center' });
            }
            return pdf;
          })
          .outputPdf('blob').then(async function(blob) {
            // blob URLを返す（新しいタブへの表示はsubmitハンドラ側で行う）
            var url = URL.createObjectURL(blob);
            setTimeout(function() { document.body.removeChild(iframe); }, 3000);

            // blob・url・base64 を返す
            try {
              var base64 = await blobToBase64(blob);
              resolve({ blob: blob, url: url, base64: base64, filename: pdfFilename });
            } catch(e) {
              resolve({ blob: null, url: url, base64: null, filename: pdfFilename });
            }
          }).catch(function(err) { document.body.removeChild(iframe); reject(err); });
        };
        script.onerror = function() { document.body.removeChild(iframe); reject(new Error('html2pdf.js の読み込みに失敗しました。')); };
        iframeDoc.head.appendChild(script);
      });
    });
  }

  // ============================================================
  // モーダル制御
  // ============================================================
  function showModal() { var o = document.getElementById('quote-modal-overlay'); if (o) { o.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function hideModal() { var o = document.getElementById('quote-modal-overlay'); if (o) { o.classList.remove('is-open'); document.body.style.overflow = ''; } }
  function getFormData() {
    var email     = document.getElementById('quote-email').value.trim();
    var lastName  = document.getElementById('quote-last-name').value.trim();
    var firstName = document.getElementById('quote-first-name').value.trim();
    var company   = document.getElementById('quote-company').value.trim();
    var fullName  = (lastName || firstName) ? (lastName + ' ' + firstName).trim() : '';
    return { email: email, lastName: lastName, firstName: firstName, fullName: fullName, company: company };
  }
  function resetForm() {
    var f = document.getElementById('quote-form'); if (f) f.reset();
    var s = document.getElementById('quote-status'); if (s) s.style.display = 'none';
  }

  // ============================================================
  // 初期化
  // ============================================================
  function init() {
    var btn = document.getElementById('btn-generate-quote');
    if (!btn) return;

    var tpl = document.getElementById('quote-modal-template');
    if (tpl) { document.body.appendChild(document.importNode(tpl.content, true)); tpl.remove(); }

    var overlay   = document.getElementById('quote-modal-overlay');
    if (overlay) overlay.classList.remove('is-open');

    var closeBtn  = document.getElementById('quote-modal-close');
    var form      = document.getElementById('quote-form');
    var submitBtn = document.getElementById('quote-submit-btn');
    var status    = document.getElementById('quote-status');

    btn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); resetForm(); showModal(); });
    if (closeBtn) closeBtn.addEventListener('click', function(e) { e.preventDefault(); hideModal(); });
    if (overlay)  overlay.addEventListener('click',  function(e) { if (e.target === overlay) hideModal(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') hideModal(); });

    if (form) {
      form.addEventListener('submit', async function(e) {
        e.preventDefault(); e.stopPropagation();
        var formData = getFormData();

        if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
          alert('有効なメールアドレスを入力してください。');
          document.getElementById('quote-email').focus(); return;
        }
        if (!formData.company) {
          alert('会社名を入力してください。');
          document.getElementById('quote-company').focus(); return;
        }


        submitBtn.disabled = true;
        submitBtn.textContent = '生成中...';
        if (status) { status.style.display = 'block'; status.textContent = '見積書を生成しています...'; status.style.color = '#666'; }

        // モバイル対応: ユーザー操作の直後（同期）に新しいタブを開いておく
        // async/await後にwindow.open()するとモバイルブラウザにブロックされる
        var pdfWindow = window.open('', '_blank');
        if (pdfWindow) {
          pdfWindow.document.write('<html><body style="background:#f5f5f5;display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;color:#555;text-align:center"><p>見積書を生成しています...<br><small>しばらくお待ちください</small></p></body></html>');
        }

        try {
          var cart = await getCartData();
          if (!cart.items || !cart.items.length) throw new Error('カートが空です。');

          var htmlTitles = await fetchDiscountTitlesFromCartHTML();
          var discounts  = collectDiscounts(cart, htmlTitles);
          var quoteNo    = generateUniqueQuoteNumber();

          // ① PDF生成
          var pdfResult   = await generatePDF(cart, formData, quoteNo, htmlTitles);
          var pdfBlob2    = pdfResult ? pdfResult.blob     : null;
          var pdfUrl      = pdfResult ? pdfResult.url      : null;
          var pdfFilename = pdfResult ? pdfResult.filename : ('ErgoPro_Quote_' + quoteNo + '.pdf');

          // ② 事前に開いたタブにPDFを表示
          if (pdfWindow && pdfUrl) {
            pdfWindow.location.href = pdfUrl;
          } else if (pdfUrl) {
            // ポップアップがブロックされた場合のフォールバック
            var a = document.createElement('a');
            a.href = pdfUrl; a.download = pdfFilename; a.style.display = 'none';
            document.body.appendChild(a); a.click();
            setTimeout(function() { a.remove(); }, 500);
          }

          // ③ メール送信（PDF表示後にバックグラウンドで実行）
          await sendNotifyEmail(quoteNo, formData, cart, discounts, pdfBlob2, pdfFilename);

          if (status) { status.textContent = '✅ 見積書（' + quoteNo + '）の生成が完了しました。'; status.style.color = '#28a745'; }
          setTimeout(function() { hideModal(); resetForm(); }, 3000);
        } catch (err) {
          if (pdfWindow) pdfWindow.close();
          console.error('[見積書] 生成エラー:', err);
          if (status) { status.textContent = '❌ エラー: ' + err.message; status.style.color = '#dc3545'; }
        } finally {
          submitBtn.disabled = false;
          submitBtn.textContent = '見積書をダウンロード';
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();